module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/Color-d6ca41faffad16f14bb37a06f91ef836.svg";